/**
 * 文件定位：
 * 1. 当前文件位于 cad-core/mesh/feature/extrude 层；
 * 2. 负责定义拉伸族正式结果体对象；
 * 3. 凸台拉伸与拉伸切除共用同一结果体骨架，差异语义由 prototype 提供。
 */

import type * as THREE from 'three';
import type { ExtrudeFeaturePrototype } from '../../../feature/prototype/extrude/ExtrudeFeaturePrototype';
import { FeatureResultObject } from '../FeatureResultObject';

/**
 * 拉伸族正式结果体对象。
 */
export class ExtrudeResultObject extends FeatureResultObject<ExtrudeFeaturePrototype> {
    /**
     * @param input 输入参数。
     */
    public constructor(input: {
        prototype: ExtrudeFeaturePrototype;
        meshData: MeshData;
        geometry: THREE.BufferGeometry;
        material: THREE.Material | THREE.Material[];
    }) {
        super(input);
    }
}
